import { TextInput } from "@/components/ui/Field";

interface MonthYearAmountFieldsProps {
  monthly: string;
  yearly: string;
  onMonthlyChange: (value: string) => void;
  onYearlyChange: (value: string) => void;
  monthlyLabel?: string;
  yearlyLabel?: string;
}

export function monthToYear(monthly: number): number {
  return monthly * 12;
}

export function yearToMonth(yearly: number): number {
  return yearly / 12;
}

export function formatAmountInput(value: number): string {
  if (!Number.isFinite(value) || value === 0) return "";
  return String(Math.round(value * 100) / 100);
}

export function MonthYearAmountFields({
  monthly,
  yearly,
  onMonthlyChange,
  onYearlyChange,
  monthlyLabel = "€/Monat",
  yearlyLabel = "€/Jahr",
}: MonthYearAmountFieldsProps) {
  return (
    <div className="grid gap-3 sm:grid-cols-2">
      <TextInput
        label={monthlyLabel}
        type="number"
        min={0}
        step={1}
        value={monthly}
        onChange={(e) => {
          const nextMonthly = e.target.value;
          onMonthlyChange(nextMonthly);
          const parsed = Number(nextMonthly);
          if (nextMonthly === "") {
            onYearlyChange("");
          } else if (Number.isFinite(parsed)) {
            onYearlyChange(formatAmountInput(monthToYear(parsed)));
          }
        }}
      />
      <TextInput
        label={yearlyLabel}
        type="number"
        min={0}
        step={1}
        value={yearly}
        onChange={(e) => {
          const nextYearly = e.target.value;
          onYearlyChange(nextYearly);
          const parsed = Number(nextYearly);
          if (nextYearly === "") {
            onMonthlyChange("");
          } else if (Number.isFinite(parsed)) {
            onMonthlyChange(formatAmountInput(yearToMonth(parsed)));
          }
        }}
      />
    </div>
  );
}
